import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/about/DesignAbout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/business/ExpandingCards.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/hero/DesignHero.tsx");
